// Shared Coupon Helpers - Movido de utils/couponHelpers
import { Coupon } from '../../types/battery'

export type AppliedCoupon = Coupon & { discountAmount?: number }

const allowedCouponTypes: Coupon['type'][] = ['percentage', 'fixed', 'free_shipping']

export const normalizeCouponData = (raw: Partial<AppliedCoupon> & { code: string }): AppliedCoupon => {
  const normalizeType = (value: unknown): Coupon['type'] => {
    if (typeof value === 'string') {
      const lowered = value.toLowerCase() as Coupon['type']
      if (allowedCouponTypes.includes(lowered)) {
        return lowered
      }
    }
    return 'percentage'
  }

  const toNumber = (value: unknown): number | undefined => {
    if (value === undefined || value === null) return undefined
    const parsed = Number(value)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  const value = toNumber(raw.value) ?? 0

  return {
    id: raw.id ?? `${raw.code}-${Date.now()}`,
    code: raw.code.toUpperCase(),
    name: raw.name ?? raw.code.toUpperCase(),
    description: raw.description ?? '',
    type: normalizeType(raw.type),
    value,
    minOrderValue: toNumber(raw.minOrderValue),
    maxDiscount: toNumber(raw.maxDiscount),
    usageLimit: toNumber(raw.usageLimit),
    usedCount: toNumber(raw.usedCount) ?? 0,
    validFrom: raw.validFrom ? new Date(raw.validFrom) : new Date(),
    validUntil: raw.validUntil ? new Date(raw.validUntil) : new Date(),
    isActive: raw.isActive ?? true,
    applicableProducts: raw.applicableProducts,
    applicableCategories: raw.applicableCategories,
    discountAmount: toNumber(raw.discountAmount),
  }
}

